import React, { useContext, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import ModalContext from '../modal/ModalContext';

import './CenterModal.module.css';

const CenterModal = ({
  children,
  id,
  onClose,
  noPadding,
  className,
  width
}) => {
  const { t } = useTranslation();
  const { showModal, hideModal } = useContext(ModalContext);

  const content = React.forwardRef(({}, ref) => (
    <div
      styleName={classnames('modal', { noPadding })}
      className={className}
      ref={ref}
      aria-modal="true"
      role="dialog"
      // "Your application might require an exception to this rule in the case of an
      //  element that captures incoming tab traversal for a composite widget. In that
      //  case, turn off this rule on a per instance basis. This is an uncommon case."
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
    >
      <div styleName="content" style={{ width: width || '80vh' }}>
        {children}
      </div>
      <button
        type="button"
        aria-label={t('Close')}
        styleName="close"
        onClick={() => {
          hideModal();
          if (onClose) {
            onClose();
          }
        }}
      >
        &#215;
      </button>
    </div>
  ));

  useEffect(
    () => {
      disableBodyScroll();
      showModal(content, id, {}, 'blind', onClose);

      return () => {
        clearAllBodyScrollLocks();
        hideModal();
      };
    },
    [id]
  );

  return null;
};

export default CenterModal;
